import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageNotFound } from '@components/common';
import {
  TrendsSharing,
  SavedDashboards,
  AppAiAlertDiagnostics,
  PreAppAiAlertDiagnostics,
  TrendsSavedDashboard,
  Prompt,
  AppExperience,
  TempAppNocDrilldown,
  TempAppVdashDrillDown,
  AccountDetails,
  SelfServeWelcome,
} from '../pages';
import {
  AppExperienceDashboardPage,
  AppExperienceComparisonPage,
  AppExperienceTempDrilldownPage,
  DPIOverviewDashboardPage,
  AppTimelinePage,
  AppAiAlertsPage,
  AppWebhooksListPage,
  AppWebhooksEditPage,
  NocPage,
  TempDashboardNocRoute,
  DashboardNocRoute,
  NocSharingRoute,
  AppTimelineSharePage,
  ECOAIAlertsCohorts,
  RemountHoC,
  NavigateWithParams,
  RedirectToHomePage,
  AppTimelineInitPage,
  NexaDashboard,
} from './FeatureCheck';
import PresetDashboardPage from './PresetDashboards';
import DrilldownDashboard from '@src/pages/main/DrilldownDashboard';
import TempDashboards from '@src/pages/SavedDashboards/TempDashboards';
import SelfServeDashboard from '@src/pages/SelfServeDashboard';

import RedirectToNexaWithId from '@src/pages/Nexa/RedirectToNexaWithId';
import AskNexa from '@src/pages/Nexa/AskNexa';
import NexaSharedView from '@src/pages/Nexa/SharedView';

import { homePagePath } from './utils';
import {
  FLOW_PRESET_DASHBOARD_ROUTE_PATH,
  FRUSTRATION_SIGNAL_PRESET_DASHBOARD_ROUTE_PATH,
  EVENT_PRESET_DASHBOARD_ROUTE_PATH,
  PRESET_DASHBOARD_ROUTE_PATH,
} from '@src/utils/constants';
const { baseUrl } = window.conviva;

const AppRouter = () => {
  return (
    <>
      <Routes>
        <Route path={homePagePath} element={<RedirectToHomePage />} />
        <Route
          path={`${baseUrl}/dashboard/app-experience`}
          element={<AppExperienceDashboardPage />}
        />
        <Route path={`${baseUrl}/dashboard/overview`} element={<DPIOverviewDashboardPage />} />
        <Route
          path={`${baseUrl}/dashboard/app-experience/sharing/:id`}
          element={<RemountHoC Component={TrendsSharing} />}
        />
        <Route
          path={`${baseUrl}/dashboard/app-experience/saved/:id`}
          element={<TrendsSavedDashboard />}
        />
        <Route path={`${baseUrl}/dashboard/saved-dashboards`} element={<SavedDashboards />} />
        <Route path={`${baseUrl}/dashboard/temp-dashboards`} element={<TempDashboards />} />
        <Route
          path={`${baseUrl}/dashboard/compare/:id`}
          element={<RemountHoC Component={AppExperienceComparisonPage} />}
        />

        <Route
          path={`${baseUrl}/dashboard/app-experience/modify-real-time`}
          element={<AppExperience />}
        />
        <Route
          path={`${baseUrl}/dashboard/app-experience/drilldown/:id`}
          element={<AppExperienceTempDrilldownPage />}
        />
        <Route path={`${baseUrl}/dashboard/user-timeline`} element={<AppTimelineInitPage />} />
        <Route path={`${baseUrl}/dashboard/user-timeline/:id`} element={<AppTimelinePage />} />
        <Route
          path={`${baseUrl}/dashboard/user-timeline/:viewerId/temp/:id`}
          element={<AppTimelinePage />}
        />
        <Route path={`${baseUrl}/dashboard/user-timeline/temp/:id`} element={<AppTimelinePage />} />
        <Route
          path={`${baseUrl}/dashboard/user-timeline/sharing/:id`}
          element={<RemountHoC Component={AppTimelineSharePage} />}
        />
        <Route
          path={`${baseUrl}/dashboard/app-experience/rt-drilldown/:id`}
          element={<RemountHoC Component={TempAppNocDrilldown} />}
        />
        <Route
          path={`${baseUrl}/dashboard/app-experience/cd-drilldown/:id`}
          element={<RemountHoC Component={TempAppVdashDrillDown} />}
        />

        <Route
          path={`${baseUrl}/dashboard/noc/:id`}
          element={<NavigateWithParams to={`${baseUrl}/dashboard/real-time/:id`} />}
        />
        <Route path={`${baseUrl}/dashboard/real-time`} element={<NocPage />} />
        <Route path={`${baseUrl}/dashboard/real-time/:id`} element={<DashboardNocRoute />} />
        <Route path={`${baseUrl}/dashboard/real-time/sharing/:id`} element={<NocSharingRoute />} />
        <Route
          path={`${baseUrl}/dashboard/real-time/temp/:id`}
          element={<TempDashboardNocRoute />}
        />
        <Route
          path={`${baseUrl}/dashboard/trends/drilldown/:id`}
          element={<RemountHoC Component={DrilldownDashboard} />}
        />
        <Route
          path={FLOW_PRESET_DASHBOARD_ROUTE_PATH}
          element={<RemountHoC Component={PresetDashboardPage} />}
        />
        <Route
          path={FRUSTRATION_SIGNAL_PRESET_DASHBOARD_ROUTE_PATH}
          element={<RemountHoC Component={PresetDashboardPage} />}
        />
        <Route
          path={EVENT_PRESET_DASHBOARD_ROUTE_PATH}
          element={<RemountHoC Component={PresetDashboardPage} />}
        />
        <Route path={PRESET_DASHBOARD_ROUTE_PATH} element={<PresetDashboardPage />} />

        <Route
          path={`${baseUrl}/dashboard/ai-alerts/pre-app-diagnostics/:aiAlertId/`}
          element={<PreAppAiAlertDiagnostics />}
        />
        <Route
          path={`${baseUrl}/dashboard/ai-alerts/diagnostics/:id`}
          element={<RemountHoC Component={AppAiAlertDiagnostics} />}
        />
        <Route path={`${baseUrl}/dashboard/ai-alerts`} element={<AppAiAlertsPage />} />
        <Route path={`${baseUrl}/dashboard/ai-cohorts`} element={<ECOAIAlertsCohorts />} />
        <Route path={`${baseUrl}/settings/webhooks`} element={<AppWebhooksListPage />} />
        <Route path={`${baseUrl}/settings/webhooks/edit/:id`} element={<AppWebhooksEditPage />} />
        <Route path={`${baseUrl}/settings/webhooks/edit`} element={<AppWebhooksEditPage />} />
        <Route path={`${baseUrl}/account/details`} element={<AccountDetails />} />
        <Route path={`${baseUrl}/dashboard/prompt`} element={<Prompt />} />
        <Route path={`${baseUrl}/welcome`} element={<SelfServeWelcome />} />
        <Route path={`${baseUrl}/self-serve/dashboard`} element={<SelfServeDashboard />} />

        <Route path={`${baseUrl}/nx/ask`} element={<AskNexa />} />
        <Route path={`${baseUrl}/nx/share/:id`} element={<NexaSharedView />} />
        <Route path={`${baseUrl}/dashboard/nexa`} element={<RedirectToNexaWithId />} />
        <Route
          path={`${baseUrl}/dashboard/nexa/:id`}
          element={<RemountHoC Component={NexaDashboard} />}
        />

        <Route element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export default AppRouter;
